import { render, staticRenderFns } from "./ZxdjEdit.vue?vue&type=template&id=47a3b72e"
import script from "./ZxdjEdit.vue?vue&type=script&lang=js"
export * from "./ZxdjEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports